import { formatAmount } from "components/utils/format_amount";

function useTotalPayoutForTestCases(testCasesCount?: number, payoutBaseAmount?: number): string {
  return formatAmount((testCasesCount || 0) * (payoutBaseAmount || 0));
}

export default useTotalPayoutForTestCases;
